var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[(_vm.isDisconnected)?_c('navbar-wallet-session-disconnected'):_c('navbar-wallet-session-connected',{attrs:{"sessions":_vm.sessions}}),_c('connect-wallet-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }